document.addEventListener("DOMContentLoaded", function () {
  const acceptanceCheckbox = document.querySelector('.js-acceptance-checkbox');
  if (acceptanceCheckbox) {
    const submitButton = document.querySelector(acceptanceCheckbox.dataset.dependant);

    acceptanceCheckbox.addEventListener('change', function () {
      submitButton.disabled = !acceptanceCheckbox.checked;
    });
  }

  const forms = document.querySelectorAll('form');
  for (let i = 0; i < forms.length; i++) {
    const form = forms[i];

    form.addEventListener('submit', function(e) {
      const input = form.querySelector('.js-phone-input');

      if (input && input.getAttribute('required')) {
        const phone = input.value.replace(/[_+() ]/g, '');

        if (phone.length < 11) {
          input.classList.add('input-group__input_error');
          e.preventDefault();
          e.stopPropagation();
        }

        input.addEventListener('focus', function() {
          this.classList.remove('input-group__input_error')
        })
      }
    });
  }
});
